import type { ApiResponse } from "@/types/apis";
import request from "@/utils/request";

// ==================== 类型定义 ====================
export interface CountryItem {
  id: string;
  name: string;
  code: string;
  shortName?: string; // 国家简称
  areaCode?: string; // 地区代码
}

// ==================== 类型定义 ====================
export interface ProvinceItem {
  id: string;
  name: string;
  code: string;
  areaCode?: string;
}

// ==================== API 接口 ====================
/**
 * 获取国家列表
 * @returns 国家列表数据
 */
export const getCountry = () =>
  request.get<ApiResponse<CountryItem[]>>("/basic/getCountry");

/**
 * 获取省份列表
 * @param areaCode 地区代码
 * @returns 省份列表数据
 */
export const getProvinceList = (areaCode: string) =>
  request.get<ApiResponse<ProvinceItem[]>>("/basic/childTreeList", {
    params: { areaCode },
  });
